import React from 'react'
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons'
import MaterialIcons from 'react-native-vector-icons/MaterialIcons'
import Ionicons from 'react-native-vector-icons/Ionicons'
import { useTheme } from 'styled-components/native'
import { Image, ImageSourcePropType, ImageStyle, ViewStyle } from 'react-native'
import { SvgFromUri, SvgProps } from 'react-native-svg'
import { isWeb } from 'APP/Helpers/checkPlatform'
import { baseColors } from 'APP/Theme/Theme'

export interface IconProps {
  src: ImageSourcePropType | string | React.FC<SvgProps>
  variant: 'image' | 'svg' | 'svgUrl' | 'material' | 'materialIcons' | 'ionicons'
  size?: number
  color?: keyof typeof baseColors
  style?: ViewStyle
  testID?: string
  fillLine?: keyof typeof baseColors
}
interface CustomSvgProps extends SvgProps {
  fillLine?: string
}

const Icon = ({
  src,
  variant,
  size = 20,
  color = 'darkText',
  style,
  testID,
  fillLine,
}: IconProps) => {
  const theme = useTheme()
  const iconColor = theme.colors[color]
  const fillLineColor = fillLine && theme.colors[fillLine]

  const switchedVariant = isWeb() && variant === 'svgUrl' ? 'image' : variant

  switch (switchedVariant) {
    case 'image':
      return (
        <Image
          style={[{ tintColor: iconColor, width: size, height: size }, style as ImageStyle]}
          source={src as ImageSourcePropType}
          resizeMode="contain"
          testID={testID}
        />
      )
    case 'svg': {
      const IconComponent = src as React.FC<CustomSvgProps>
      return (
        <IconComponent fill={iconColor} style={style} testID={testID} fillLine={fillLineColor} />
      )
    }
    case 'svgUrl':
      return (
        <SvgFromUri
          uri={src as string}
          color={iconColor}
          fill={iconColor}
          width={size}
          height={size}
          style={style}
          testID={testID}
        />
      )
    case 'material':
      return (
        <MaterialCommunityIcons
          name={src as string}
          size={size}
          color={iconColor}
          style={style}
          testID={testID}
        />
      )
    case 'materialIcons':
      return (
        <MaterialIcons
          name={src as string}
          size={size}
          color={iconColor}
          style={style}
          testID={testID}
        />
      )
    case 'ionicons':
      return (
        <Ionicons
          name={src as string}
          size={size}
          color={iconColor}
          style={style}
          testID={testID}
        />
      )
    default:
      return null
  }
}

export default Icon
